<template>
    <div>
        <base-page-header :breadcrumb="breadcrumb" :title="$t('environmental-management.egar.title')" />

        <v-row class="bg-white mb-10">
            <v-col cols="12" sm="4" style="display: flex; align-items: baseline;">
                <v-btn
                    :loading="showLoadingBtn.show"
                    :disabled="showLoadingBtn.show"
                    @click="updateEgars"
                    class="primary mt-3"
                >
                    {{$t('environmental-management.egar.sincronize-egars')}}
                </v-btn>

                <span class="text-status-btn" v-if="showLoadingBtn.text != ''">
                    {{showLoadingBtn.text}} - {{showLoadingBtn.date | formatDate}}
                </span>
            </v-col>
            <v-col cols="8">
                <v-col cols="12">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <div class="float-md-right mr-md-4 btn-add" @click="$router.push({ name: 'environmentalManagementEGARNew'})"  v-bind="attrs" v-on="on">
                                <img src="/images/_SVGs/bo/adicionar.svg" onload="SVGInject(this)" class="circle" width="20" />
                            </div>
                        </template>
                        <span>{{$t('environmental-management.egar.new-egar')}}</span>
                    </v-tooltip>
                </v-col>
            </v-col>
            <v-col cols="12">
                <!-- <SearchForm @on-search="onSearch" @on-search-free="searchFree" :actorsTypes="actorsTypes"/> -->
                <SearchForm @on-search="onSearch" :actorsTypes="actorsTypes"/>
                <v-data-table
                    class="elevation-1"
                    :headers="headers"
                    :items="dados"
                    :server-items-length="totalItemsTable"
                    :page="page"
                    :pageCount="numberOfPages"
                    :options.sync="options"
                    :footer-props="{
                        showFirstLastPage: true,
                        'items-per-page-options': [10, 20, 50]
                    }"
                >
                <!-- :search="searchFreeText" -->
                    <template v-slot:[`item.egarNumber`]="{ item }">
                        <p class="title-table">{{item.egarNumber}}</p>
                        <p class="subTitle-table">{{item.egarCode}}</p>
                    </template>
                    <template v-slot:[`item.qtd`]="{ item }">
                        {{item.transportedResidue.quantity}}
                    </template>
                    <template v-slot:[`item.transportedResidue`]="{ item }">
                        <div v-if="item.correctedTransportedResidue.length > 0">
                            <p class="title-table">{{item.correctedTransportedResidue.operationCode}}</p>
                            <p class="subTitle-table">{{item.correctedTransportedResidue.correctedResidueLerCode}} - {{item.correctedTransportedResidue.residueDescription.substr(0, 16)}}...</p>
                        </div>
                        <div v-else>
                            <p class="title-table">{{item.transportedResidue.designation}}</p>
                            <p class="subTitle-table">{{item.transportedResidue.residueLerCode}} - {{item.transportedResidue.residueDescription.substr(0, 16)}}...</p>
                        </div>
                    </template>
                    <template v-slot:[`item.corrected-qtd`]="{ item }">
                        <div v-if="Object.keys(item.correctedTransportedResidue).length">
                            {{item.correctedTransportedResidue.correctedQuantity}}
                        </div>
                        <div v-else>
                            -
                        </div>
                    </template>
                    <template v-slot:[`item.sender`]="{ item }">
                        <p class="title-table">{{item.sender.nif}} - {{item.sender.name}}</p>
                        <p class="subTitle-table">{{item.sender.establishment.apaCode}} - {{item.sender.establishment.establishmentName}}</p>
                    </template>
                    <template v-slot:[`item.recipient`]="{ item }">
                        <p class="title-table">{{item.recipient.nif}} - {{item.recipient.name}}</p>
                        <p class="subTitle-table">{{item.recipient.establishment.apaCode}} - {{item.recipient.establishment.establishmentName}}</p>
                    </template>
                    <template v-slot:[`item.tranporters`]="{ item }">
                        <p class="title-table">{{item.tranporters.nif}} - {{item.tranporters.name}}</p>
                    </template>
                    <template v-slot:[`item.statusCode`]="{ item }">
                        <div v-html="getStatusIcon(item.statusCode)"></div>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                        <v-menu
                            bottom
                            offset-y
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    text
                                    class="ma-2"
                                    v-bind="attrs"
                                    v-on="on"
                                    :disabled="showLoadingBtn.show"
                                >
                                    <span class="actions">...</span>
                                </v-btn>
                            </template>
                            <v-list class="list-menu">
                                <ul>
                                    <li>
                                        <a class="cursor-pointer" @click="verifyProducer(item, false)">
                                            <img src="/images/_SVGs/environmental/duplicate.svg" :alt="$t('environmental-management.egar.duplicate')" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                                            {{$t('environmental-management.egar.duplicate')}}
                                        </a>
                                    </li>
                                    <li  v-if="item.statusCode != 'AN'">
                                        <a @click="getArchive(item)" target="_blank">
                                            <img src="/images/_SVGs/environmental/download-button.svg" :alt="$t('environmental-management.egar.download')" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                                            {{$t('environmental-management.egar.download')}}
                                        </a>
                                    </li>
                                    <li>
                                        <a class="cursor-pointer" @click="verifyProducer(item, true)">
                                            <img src="/images/_SVGs/environmental/edit_pencil.svg" :alt="$t('environmental-management.egar.edit')" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                                            {{$t('environmental-management.egar.edit')}}
                                        </a>
                                    </li>
                                    <li  v-if="item.statusCode != 'AN'">
                                        <a @click="showModalEmail(item)">
                                            <img src="/images/_SVGs/environmental/email.svg" :alt="$t('environmental-management.egar.email')" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                                            {{$t('environmental-management.egar.email')}}
                                        </a>
                                    </li>
                                </ul>
                            </v-list>
                        </v-menu>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <base-modal v-model="modalAlert.show" :title="$t('heads-up')" modal-width="560px" >
            <template v-slot:modal-close>
                <div @click="modalAlert.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                {{modalAlert.msg}}
            </template>

            <template v-slot:modal-actions>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="modalAlert.show = false">
                        {{$t('ok')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal v-model="modalEmail.show" :title="$t('environmental-management.egar.modal-email.title')" modal-width="560px" >
            <template v-slot:modal-close>
                <div @click="cancelarEmail()">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                <v-form v-model="modalEmail.isValid">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                :label="$t('environmental-management.egar.modal-email.name-req-label')"
                                v-model="modalEmail.name"
                                :rules="formRules.defaultRules"
                                filled
                                hide-details="auto"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field
                                :label="$t('environmental-management.egar.modal-email.email-req-label')"
                                v-model="modalEmail.email"
                                :rules="formRules.defaultRules"
                                filled
                                hide-details="auto"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="cancelarEmail()">
                        {{$t('cancel')}}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="enviarEgar()" :disabled="!modalEmail.isValid">
                        {{$t('send')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal v-model="modalEditEgar.show" :title="$t('environmental-management.egar.modal-edit-egar.title')" modal-width="560px" :persistent="true">
            <template v-slot:modal-close>
                <div @click="modalEditEgar.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                <v-col class="text-center">
                    <div>
                        <v-btn
                            class="primary-button btn"
                            @click="navigate(modalEditEgar.egarSelect, modalEditEgar.isEdit, true)"
                        >
                            {{$t('environmental-management.egar.modal-edit-egar.producer')}}
                        </v-btn>

                        <v-btn
                            class="primary-button btn ml-2"
                            @click="navigate(modalEditEgar.egarSelect, modalEditEgar.isEdit, false)"
                        >
                            {{$t('environmental-management.egar.modal-edit-egar.adressee')}}
                        </v-btn>
                    </div>
                </v-col>

            </template>

            <template v-slot:modal-actions>
                <div>
                    <v-btn class="danger-button" text @click="modalEditEgar.show = false">
                        {{$t('cancel')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
import {GetActorsSenders, GetActorsTypes} from '@services/b2b/environmental-management/EgarService';

import {GetTranporterGuideEgar} from '@services/b2b/environmental-management/RouterService'
import {GetSILiAmbEgars, SendEmailEgar} from '@services/b2b/environmental-management/EgarManagementService'
import {required} from '@src/utils/validations.js';
import SearchForm from '@components/b2b/environmental-management/EGAR/SearchForm';
import BaseModal from "@components/shared/widgets/BaseModal.vue";
import BasePageHeader from "@components/shared/widgets/pages-header/BasePageHeader.vue";

export default {

        components:{
            BasePageHeader,
            BaseModal,
            SearchForm
        },

        data(){
            return{
                searchFreeText: null,
                breadcrumb: [
                    {
                        title: this.$t('environmental-management.title'),
                        routerLinkName: 'environmentalManagement'
                    },
                    {
                        title: this.$t('environmental-management.egar.title'),
                    }
                ],
                headers: [
                    {
                        text: this.$t('environmental-management.egar.headers.nbr-gar'),
                        align: 'start',
                        value: 'egarNumber',
                        sortable: false
                    },
                    { text: this.$t('environmental-management.egar.headers.qtd'), value: 'qtd', sortable: false },
                    { text: this.$t('environmental-management.egar.headers.residue'), value: 'transportedResidue', sortable: false },
                    { text: this.$t('environmental-management.egar.headers.corrected-qtd'), value: 'corrected-qtd', sortable: false },
                    { text: this.$t('environmental-management.egar.headers.producer'), value: 'sender', sortable: false },
                    { text: this.$t('environmental-management.egar.headers.recipient'), value: 'recipient', sortable: false },
                    { text: this.$t('environmental-management.egar.headers.transporter'), value: 'tranporters', sortable: false },
                    { text: this.$t('environmental-management.egar.headers.status'), value: 'statusCode', sortable: false },
                    { text: '', value: 'action', sortable: false },
                ],
                formRules: {
                    defaultRules: [required]
                },
                modalAlert:{
                    show:false,
                    msg: ''
                },
                modalEmail:{
                    show:false,
                    isValid: false,
                    email: '',
                    name: '',
                    egarNumber: '',
                    egarCode: '',
                    egarLink: ''
                },
                dados:[],
                filters: [],
                filterSearch: {
                    establishmentApaCode: '',
                    statusCode: '',
                    statusDate: '',
                    issueDate: '',
                    pendingAuthorization: '',
                    isUpdate: false,
                    interveningTypeId: null
                },
                isUpdateClicked: false,
                dadosOriginals: [],
                actorsSenders: [],
                actorsTypes: [],
                selectActorsSenders: 1,
                modalEditEgar: {
                    show: false,
                    egarSelect: null,
                    isEdit: true
                },
                totalItemsTable: 0,

                page: 1,
                numberOfPages:1,
                options: {
                    page: 1,
                    itemsPerPage: 10
                },
                tableFiltersOld: {},
                searchCount: 0,
            }
        },

        computed: {
            userState() {
                return this.$store.getters['auth/getState'];
            },
            showLoadingBtn() {
                return this.$store.getters['loadings/getLoadingState'].loadings.loadingBtn;
            },
        },

        watch: {
            "options.page": {
                handler: function(newValue, oldValue) {
                    this.alterTableEgar(this.options);
                },
            },
            "options.itemsPerPage": {
                handler() {
                    this.alterTableEgar(this.options);
                },
            },
            // searchCount:{
            //     handler() {
            //         this.options.page = 1
            //     },
            // },
        },

        methods:{
            getStatusIcon(status){
                switch(status){
                    case 'AA':
                        return `<div class="pendente">
                            <img src="/images/_SVGs/environmental/pendente.svg" alt="Status" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            ${this.$t('environmental-management.egar.status-icon.pendent')}
                        </div>`;
                    case 'EM':
                        return `<div class="emidita">
                            <img src="/images/_SVGs/environmental/emitir.svg" alt="Status" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            ${this.$t('environmental-management.egar.status-icon.emitt')}
                        </div>`
                    case 'AN':
                        return `<div class="anulada">
                            <img src="/images/_SVGs/environmental/anular.svg" alt="Status" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            ${this.$t('environmental-management.egar.status-icon.canceled')}
                        </div>`
                    case 'CC':
                        return `<div class="concluir">
                            <img src="/images/_SVGs/environmental/check.svg" alt="Status" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            ${this.$t('environmental-management.egar.status-icon.finish')}
                        </div>`
                    case 'CO':
                        return `<div class="corrigido">
                            <img src="/images/_SVGs/environmental/corrigir.svg" alt="Status" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            ${this.$t('environmental-management.egar.status-icon.adjusted')}
                        </div>`
                    case 'CN':
                        return `<div class="anulada">
                            <img src="/images/_SVGs/environmental/anular.svg" alt="Status" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            ${this.$t('environmental-management.egar.status-icon.correction-denied')}
                        </div>`
                    case 'RJ':
                        return `<div class="anulada">
                        <img src="/images/_SVGs/environmental/anular.svg" alt="Status" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                        ${this.$t('environmental-management.egar.status-icon.rejected')}
                    </div>`
                    case 'AC':
                        return `<div class="concluir">
                            <img src="/images/_SVGs/environmental/check.svg" alt="Status" class="mr-3" onload="SVGInject(this)" width="15" height="15" />
                            ${this.$t('environmental-management.egar.status-icon.accpeted')}
                        </div>`

                    default:
                        return '-';
                }
            },
            updateEgars(){
                this.isUpdateClicked = true;
                this.getAllUpdateEGAR()
            },
            getActorsSender(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                return GetActorsSenders()
                    .then(response => {
                        if(response.data.result.length > 0){
                            this.actorsSenders = response.data.result
                        }
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get GetActorsSenders values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                        // this.getAllEGAR();
                    })
            },
            getActors_Types(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                return GetActorsTypes()
                    .then(response => {
                            this.actorsTypes = response.data.result
                            this.selectActorsSenders = 1
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        throw new Error('error to get GetActorsSenders values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                        // this.getAllEGAR();
                    })
            },
            searchFree(e){
                let data = [];
                e = e.toLowerCase();
                for (let key in this.dadosOriginals) {
                    for (let i in this.dadosOriginals[key]) {
                        if(typeof this.dadosOriginals[key][i] === 'object'){
                            for (let u in this.dadosOriginals[key][i]){

                                if(typeof this.dadosOriginals[key][i][u] === 'object'){
                                    for (let k in this.dadosOriginals[key][i][u]){
                                        if(typeof this.dadosOriginals[key][i][u][k] !== 'object'){
                                            if(this.dadosOriginals[key][i][u][k].toLowerCase().includes(e)){
                                                data.push(this.dadosOriginals[key])
                                            }
                                        }
                                    }
                                }else{
                                    if(this.dadosOriginals[key][i][u].toLowerCase().includes(e)){
                                        data.push(this.dadosOriginals[key])
                                    }
                                }
                            }
                        }else{
                            if(typeof this.dadosOriginals[key][i] !== 'boolean'){
                                if(this.dadosOriginals[key][i].toLowerCase().includes(e)){
                                    data.push(this.dadosOriginals[key])
                                }
                            }
                        }

                    }
                }
                this.dados = _.sortedUniq(data)
            },
            getArchive(item) {
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                try {
                    window.open(item.fileName, '_blank');
                } catch (e) {
                    if(!item.fileName) {
                        window.open(item.url,'_blank');
                        return
                    }
                } finally {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                    return
                }

                // return GetTranporterGuideEgar(item.fileName)
                // .then(response => {
                //     window.open(response.data,'_blank');
                // })
                // .catch(error => {
                //     this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                //     throw new Error('error to get GetTranporterGuideEgar egar values', error);
                // })
                // .finally(() => {
                //     this.$store.commit('loadings/setStateLoadingTemplate', false);
                // })

                return GetTranporterGuideEgar(item.fileName)
                .then(response => {
                    window.open(response.data.result,'_blank');
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error to get GetTranporterGuideEgar egar values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })

            },
            showModalEmail(item){
                this.modalEmail.egarNumber = item.egarNumber
                this.modalEmail.egarCode = item.egarCode
                this.modalEmail.egarLink = item.url
                this.modalEmail.show = true;
            },
            cancelarEmail(){
                this.modalEmail = {
                    show:false,
                    email: '',
                    name: '',
                    egarNumber: '',
                    egarCode: '',
                    egarLink: ''
                }
            },
            enviarEgar(){
                this.modalEmail.show = false;
                const body = {
                    "email": this.modalEmail.email,
                    "name": this.modalEmail.name,
                    "egarNumber": this.modalEmail.egarNumber,
                    "egarCode": this.modalEmail.egarCode,
                    "egarLink": this.modalEmail.egarLink
                }

                this.$store.commit('loadings/setStateLoadingTemplate', true);

                SendEmailEgar(body)
                .then(response => {
                    this.modalEmail = {
                        show:false,
                        email: '',
                        name: '',
                        egarNumber: '',
                        egarCode: '',
                        egarLink: ''
                    }
                    this.modalAlert.msg = this.$t('environmental-management.egar.modal-alert.msg1');
                    this.modalAlert.show = true;
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                    this.modalAlert.msg = this.$t('environmental-management.egar.modal-alert.msg2');
                    this.modalAlert.show = true;
                    throw new Error('error to get list SendEmailEgar values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            verifyProducer(item, isEdit) {

                if((this.userState.roleId == 1 || this.userState.roleId == 2) && this.userState.isAdminSILiAmb){
                    if((item.sender.nif == item.recipient.nif && item.recipient.nif == this.userState.nif.substr(2)) || (item.isProducerCredential)){
                        this.modalEditEgar = {
                            egarSelect: item,
                            isEdit: isEdit,
                            show: true
                        }
                    }else{
                        this.navigate(item, isEdit, false);
                    }
                }
                else{
                    if((item.sender.nif == this.userState.nif.substr(2)) && item.recipient.nif == this.userState.nif.substr(2)){
                        this.modalEditEgar = {
                            egarSelect: item,
                            isEdit: isEdit,
                            show: true
                        }
                    }else if(item.sender.nif == this.userState.nif.substr(2)){
                        this.navigate(item, isEdit, true);
                    }else{
                        this.navigate(item, isEdit, false);
                    }
                }
            },
            navigate(item, isEdit, isProducer) {
                if(isEdit){
                    if(isProducer)
                        this.$router.push({name: 'environmentalManagementEGAREditProducer', params: {egarNum: item.egarNumber, egarCode: item.egarCode}})
                    else
                        this.$router.push({name: 'environmentalManagementEGAREdit', params: {egarNum: item.egarNumber, egarCode: item.egarCode}})
                }else{
                    item.actorCode = isProducer ? 'p': 'D';
                    this.$router.push({name: 'environmentalManagementEGARNew', params: {egar: item}})
                }
            },
            valideMenu(statusCode, num){
                //duplicar
                if(num == 1){
                    return statusCode == 'CC' || statusCode == 'EM' || statusCode == 'CO' || statusCode == 'RJ' || statusCode == 'AN';
                }

                //Descarregar
                if(num == 2){
                    return statusCode == 'CC' || statusCode == 'EM' || statusCode == 'CO' || statusCode == 'RJ';
                }

                return true;
            },
            onSearch(event) {
                this.tableFiltersOld = _.cloneDeep(this.filterSearch);

                this.filterSearch = {
                    //establishmentApaCode: event.searchText,
                    searchText: event.searchText,
                    statusCode: event.status,
                    statusDate: event.data,
                    issueDate: event.issueDate,
                    isUpdate: false,
                    interveningTypeId: event.interveningTypeId,
                };

                this.searchCount = this.searchCount + 1;

                const checkFilters = this.$compareObjects.compareTwoObjects(this.tableFiltersOld, this.filterSearch);
                if(!checkFilters) {
                    if(this.searchCount == 0 && this.options.page == 1) {
                        // this.searchCount = this.searchCount + 1;
                        this.getAllEGAR();
                        return;
                    } else if (this.options.page > 1 && this.searchCount == 0) {
                        this.options.page = 1;
                        this.searchCount = this.searchCount + 1;
                        return;
                    } else if (this.options.page > 1 && this.searchCount > 0) {
                        this.options.page = 1;
                    } else {
                        this.getAllEGAR();
                    }
                }
            },
            getAllEGAR(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                this.dados = [];
                this.dadosOriginals = [];

                GetSILiAmbEgars(this.filterSearch)
                    .then(response => {
                        this.dados = response.data.result
                        this.dadosOriginals = this.dados;
                        this.totalItemsTable = response.data.totalRecords;
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        if(error.response.status == 409){
                            this.modalAlert.msg = error.response.data.errorMessage
                        }else{
                            this.modalAlert.msg = this.$t('environmental-management.egar.modal-alert.msg3');
                        }
                        this.modalAlert.show = true;
                        throw new Error('error to get list GetSILiAmbEgars values', error);
                    })
                    .finally(() => {
                        this.$store.commit('loadings/setStateLoadingTemplate', false);
                    })
            },
            getAllUpdateEGAR(){
                this.$store.commit('loadings/setLoadingBtnStatusState', true);

                if(this.isUpdateClicked){
                    this.filterSearch.isUpdate = true;
                    this.filterSearch['pageSize'] = 200;
                }

                GetSILiAmbEgars(this.filterSearch)
                    .then(response => {
                        this.dados = [];
                        this.dadosOriginals = [];

                        this.dados = response.data.result

                        this.dadosOriginals = this.dados;

                        this.$store.commit('loadings/setLoadingBtnTextState', 'Egars Sincronizadas');
                        this.$store.commit('loadings/setLoadingBtnDateState', Date());
                    })
                    .catch(error => {
                        this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                        if(error.response.status == 409){
                            this.modalAlert.msg = error.response.data.errorMessage
                        }else{
                            this.modalAlert.msg = this.$t('environmental-management.egar.modal-alert.msg4');

                        }
                        this.modalAlert.show = true;
                        throw new Error('error to get list GetSILiAmbEgars values', error);
                    })
                    .finally(() => {
                        this.isUpdateClicked = false;
                        this.$store.commit('loadings/setLoadingBtnStatusState', false);
                    })
            },
            alterTableEgar(options) {

                this.itemsPerPage = options.itemsPerPage
                Object.assign(this.filterSearch, {
                        pageSize: options.itemsPerPage,
                        currentPage: options.page
                    }
                )
                this.getAllEGAR();

            },
        },
        mounted() {
            this.getActors_Types();
            this.getAllEGAR();
        }
    }
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';
.text-status-btn{
    margin-left: 20px;
    font-size: 14px;
    color: #005e7f;
}
.action-div{
    float: right;
    .icon-action{
        display: inline-block;

    }
    .circle {
        width: 30px;
        height: 30px;
        background: var(--v-primary-lighten5);
        padding: 3px;
        ::v-deep path{
            fill: var(--v-primary-base);
        }
    }
}


::v-deep table{
    thead {

        th{
            font-size: 13px !important;
            border: 1px solid rgb(224 224 224);
            height: 30px !important;
            background: $grey-light;
            color:rgb(113 113 113 / 60%) !important;
        }
    }
    tbody{
        td{
            border: 1px solid rgb(224 224 224);
            font-size: 13px !important;
            p{
                margin-bottom: 0;
                &.subTitle-table{
                    margin-top: 3px;
                    color: #c5c2c2;
                }
            }
        }
    }
}
.v-btn:disabled{
    .actions{
        color: #ccc !important;
    }
}
.pendente{
    opacity: 0.5;
    font-weight: 500;
}
.emidita{
    font-weight: 500;
}
::v-deep .anulada{
    color: red;
    font-weight: 500;
    svg{
        path{
            fill: red;
        }
    }
}
::v-deep .concluir{
    color: green;
    font-weight: 500;
    svg{
        path{
            fill: green !important;
        }
    }
}
::v-deep .corrigido{
    color: #F59534;
    font-weight: 500;
    svg{
        path{
            fill: #F59534;
        }
    }
}

.actions{
    color: var(--v-primary-base);
    font-weight: 600;
    font-size: 25px;
}

.list-menu{
    ul{
        padding: 0 0;
        li{
            padding: 5px 10px;
            display: block;
            a{
                width: 100%;
                height: 100%;
                display: block;
                color: $grey;
                ::v-deep svg{
                    path{
                        fill: $grey;
                    }
                }
            }
            &:hover{
                background: var(--v-primary-base);
                a{
                    color: #ffffff;
                    ::v-deep svg{
                        path{
                            fill: #ffffff;
                        }
                    }
                }
            }
        }
    }
}
.cursor-pointer{
    cursor: pointer;
}
.btn-add{
    cursor: pointer;
    .circle{
        background: var(--v-primary-base);
        width: 40px;

        ::v-deep path{
            fill: #ffffff !important;
        }
    }
    &:hover{
        .circle{
            background: var(--v-primary-lighten3);
        }
    }
}
</style>
